import React, { useState } from 'react';

const Customer = ({ customer }) => {
  const [tab, setTab] = useState('address');

  const {
    name = '', street = '', zip = '', city = '', country = '', registrationname = '',
    delivery = {}, payee = {}, taxrepresentative = {}
  } = customer;

  return (
    <div className="customer">
      <div className={`customer-tab ${tab}`}>
        {(payee.name || delivery.name) && <div
          className="tab-address"
          onClick={() => setTab('address')}
        >
          Adresse
        </div>}
        {delivery.name && <div
          className="tab-delivery"
          onClick={() => setTab('delivery')}
        >
          Liefer-Adresse
        </div>}
        {payee.name && <div
          className="tab-payee"
          onClick={() => setTab('payee')}
        >
          Rechnungs-Adresse
        </div>}
        {taxrepresentative.name && <div
          className="tab-tax"
          onClick={() => setTab('tax')}
        >
          Steuer-Adresse
        </div>}
      </div>

      {tab === 'address' && <div className="address">
        <div className="address-line">
          {name && <div>{name}</div>}
          {registrationname && name !== registrationname && <div>{registrationname}</div>}
          <div>{customer.person?.firstname} {customer.person?.lastname}</div>
          <div>{street}</div>
          <div>{country} {zip} {city}</div>
        </div>
        <br />
        <div>{customer.contact?.name}</div>
        <div>{customer.contact?.phone}</div>
        <div>{customer.contact?.email}</div>
        {customer.contact?.name || customer.contact?.phone || customer.contact?.email ? <br /> : ''}
      </div>}

      {tab === 'delivery' && <div className="deliveryaddress">
        <div className="address-line">
          <div>{delivery.name}</div>
          <div>{delivery.street}</div>
          <div>{delivery.country} {delivery.zip} {delivery.city}</div>
        </div>
        <br /><div /><div /><div />
      </div>}

      {tab === 'payee' && <div className="payeeaddress">
        <div className="address-line">
          <div>{payee.name}</div>
          <div>{payee.street}</div>
          <div>{payee.country} {payee.zip} {payee.city}</div>
        </div>
        <br /><div /><div /><div />
      </div>}

      {tab === 'tax' && <div className="taxaddress">
        <div className="address-line">
          <div>{taxrepresentative.name}</div>
          <div>{taxrepresentative.street}</div>
          <div>{taxrepresentative.country} {taxrepresentative.zip} {taxrepresentative.city}</div>
          <div>ID: {taxrepresentative.taxid}</div>
        </div>
        <br /><div /><div /><div />
      </div>}
    </div>
  )
}

export default Customer
